import { render } from "./YPContact.vue?vue&type=template&id=65700e65"
import script from "./YPContact.vue?vue&type=script&lang=js"
export * from "./YPContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__